import { cn } from "lib/utils";







const LOGO_MARK_SRC = `${process.env.PUBLIC_URL ?? ""}/assets/images/logos/fortify_logo.svg`;

export function Logo({ className, size = "md", showText = true }) {
  const sizeClasses = {
    sm: "text-lg",
    md: "text-xl",
    lg: "text-2xl"
  };

  const markClasses = {
    sm: "h-7 w-7",
    md: "h-8 w-8",
    lg: "h-10 w-10"
  };

  return (
    <div className={cn("flex items-center gap-2", className)}>
      <img
        src={LOGO_MARK_SRC}
        alt={showText ? "" : "Fortify"}
        width={size === "sm" ? 28 : size === "lg" ? 40 : 32}
        height={size === "sm" ? 28 : size === "lg" ? 40 : 32}
        className={cn("shrink-0 object-contain", markClasses[size])}
        draggable={false}
        aria-hidden={showText ? true : undefined} />
      
      {showText && <span className={cn("font-bold tracking-tight", sizeClasses[size])}>
      Fortify
      </span>}
    </div>);

}